var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mode === 'auto')?_c('button',{staticClass:"rp-buy-button rp-button",style:({
    backgroundColor: _vm.openCart === false ? _vm.color.secondarySub:_vm.color.secondaryMain,
    color: _vm.openCart === false ? _vm.color.secondaryMain:_vm.color.secondarySub,
    borderColor: _vm.color.secondaryMain,
    fontFamily: _vm.globalFont
  }),on:{"click":_vm.addToCart}},[(_vm.openCart === false)?_c('span',{staticClass:"rp-icon"},[_c('i',{staticClass:"fa fa-plus"})]):_c('span',{staticClass:"rp-icon"},[_c('i',{staticClass:"fa fa-shopping-cart"})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rpLabel))])]):_c('button',{staticClass:"rp-buy-button rp-button-custom",style:({
    backgroundColor: _vm.color.secondaryMain,
    color: _vm.color.secondarySub,
    borderColor: _vm.color.secondaryMain,
    fontFamily: _vm.globalFont
  }),on:{"click":_vm.addToCart}},[(_vm.mode === 'auto')?_c('span',{staticClass:"rp-icon"},[_c('i',{staticClass:"fa fa-shopping-cart"})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rpLabel))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0913fb6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddToCartButton.vue
// module id = null
// module chunks = 